export default __webpack_public_path__ + "static/media/Layer 2.00c4b2d6.svg";